import { render, staticRenderFns } from "./DocumentList-importcsv.vue?vue&type=template&id=5976c938&"
import script from "./DocumentList-importcsv.vue?vue&type=script&lang=js&"
export * from "./DocumentList-importcsv.vue?vue&type=script&lang=js&"
import style0 from "./DocumentList-importcsv.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/filepond.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports